import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'
import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export const getTrackingMetaData = (displayTitle: string): TrackingMetaData => ({
  context: {
    contentContainerType: CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DISPLAY,
    contentContainerName: CUSTOM_SECTION_CONTAINER_NAMES.SINGLE_SWIMLANE,
    // @i18n-ignore
    trackingId: 'more-to-explore',
    contentContainerDisplayName: displayTitle,
  },
})
